export default "__VITE_ASSET__DyjwS7dJ__"